import React from "react";
import styled from "styled-components";
import categoryImg1 from "../images/home/categoryImg1.webp";
import categoryImg2 from "../images/home/categoryImg2.webp";
import categoryImg3 from "../images/home/categoryImg3.webp";
import categoryImg4 from "../images/home/categoryImg4.webp";
import categoryImg5 from "../images/home/categoryImg5.webp";
import categoryImg6 from "../images/home/categoryImg6.webp";
import categoryImg7 from "../images/home/categoryImg7.webp";
import categoryImg8 from "../images/home/categoryImg8.webp";
import categoryImg9 from "../images/home/categoryImg9.webp";

const categories = [
  { img: categoryImg1, title1: "ON OUR", title2: "BOOKSHELF" },
  { img: categoryImg2, title1: "SCRIPTURAL", title2: "APPAREL" },
  { img: categoryImg3, title1: "ABUNDANT", title2: "KITCHEN" },
  { img: categoryImg4, title1: "PLANNERS &", title2: "CALENDARS" },
  { img: categoryImg5, title1: "BIBLES", title2: "" },
  { img: categoryImg6, title1: "CHRISTIAN", title2: "CRAFT CORNER" },
  { img: categoryImg7, title1: "HEAVENLY", title2: "HOME DECOR" },
  { img: categoryImg8, title1: "GIFTING", title2: "ACCESSORIES" },
  { img: categoryImg9, title1: "SCRIPTURE", title2: "SIPPERS" }
];

const CategoryStrip = () => {
  return (
    <Wrapper>
      <Strip>
        {categories.map((cat, index) => (
          <Category key={index}>
            <IconCircle>
              <img src={cat.img} alt={cat.title1} />
            </IconCircle>

            <Label>
              <span>{cat.title1}</span>
              {cat.title2 && <span>{cat.title2}</span>}
            </Label>
          </Category>
        ))}
      </Strip>
    </Wrapper>
  );
};

export default CategoryStrip;

/* -------------- STYLED COMPONENTS ---------------- */

const Wrapper = styled.div`
  width: 100%;
//   background: #f3ece6;
background: #fffff;
  padding: 30px 150px;
  display: flex;
  justify-content: center;

  @media (max-width: 1024px) {
    padding: 40px 40px;
  }

  @media (max-width: 600px) {
    padding: 30px 20px;
  }
`;

const Strip = styled.div`
  display: grid;
  grid-template-columns: repeat(9,1fr);
  justify-items: center;
  align-items: start;
//   gap: 25px 15px;
  width: 80%;
  max-width: 1400px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    gap: 20px 10px;
  }

  @media (max-width: 600px) {
    grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
    gap: 18px 8px;
  }
`;

const Category = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;

  &:hover img {
    transform: scale(1.1);
    transition: 0.3s ease;
  }
`;

const IconCircle = styled.div`
  width: 70px;
  height: 70px;
//   border-radius: 50%;
//   border: 3px solid #919796ff;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;

  img {
    width: 60px;
    height: 60px;
    object-fit: contain;
    transition: 0.3s ease;
  }

  @media (max-width: 600px) {
    width: 55px;
    height: 55px;

    img {
      width: 48px;
      height: 48px;
    }
  }
`;

const Label = styled.div`
  margin-top: 10px;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  color: #334b48;

  span {
    display: block;
    line-height: 16px;
  }

  @media (max-width: 600px) {
    font-size: 10px;
    line-height: 14px;
  }
`;
